/* v64 (2026-04-21): THE REAL FIX. Confirmed via live browser inspection:
   the backend reads diamondcolor / diamondcut / diamondclarity as
   COMMA-SEPARATED VALUE LISTS, not slider ranges. The sliders are purely
   visual — they never actually write to these fields.

   v64 hooks polish-bar slider changes + tick clicks and writes the exact
   value list that corresponds to the selected range. Tapping a tick pins
   both handles to that single index → writes a single value → API returns
   only that grade. */
(function(){
  var DEFS = {
    cut:     { values: ['Good','Very Good','Excellent','Ideal'], allSuffix: ',8X', input: 'diamondcut' },
    color:   { values: ['K','J','I','H','G','F','E','D'],       allSuffix: '',    input: 'diamondcolor' },
    clarity: { values: ['SI2','SI1','VS2','VS1','VVS2','VVS1','IF','FL'], allSuffix: '', allPrefix: 'I1,', input: 'diamondclarity' }
  };
  var KEYS = Object.keys(DEFS);

  function valueListForRange(key, lo, hi) {
    var d = DEFS[key];
    var full = d.values.length - 1;
    if (lo <= 0 && hi >= full) {
      // ALL — empty for color (theme convention), default list for cut/clarity
      if (key === 'color') return '';
      return (d.allPrefix || '') + d.values.join(',') + (d.allSuffix || '');
    }
    var slice = d.values.slice(Math.max(0, Math.round(lo)), Math.round(hi) + 1);
    return slice.join(',');
  }

  function setInput(id, val) {
    var i = document.getElementById(id);
    if (!i) return;
    i.value = val;
    ['input','change'].forEach(function(n){ try { i.dispatchEvent(new Event(n, { bubbles: true })); } catch(e){} });
    if (window.jQuery) { try { window.jQuery(i).trigger('change'); } catch(e){} }
  }

  var syncT = null;
  function scheduleApply() {
    clearTimeout(syncT);
    syncT = setTimeout(function(){
      KEYS.forEach(function(key){
        var col = document.querySelector('.sp-bn__col[data-key="'+key+'"]');
        if (!col) return;
        var minH = col.querySelector('.sp-rng__handle--min');
        var maxH = col.querySelector('.sp-rng__handle--max');
        if (!minH || !maxH) return;
        var lo = parseFloat(minH.value);
        var hi = parseFloat(maxH.value);
        if (isNaN(lo) || isNaN(hi)) return;
        var list = valueListForRange(key, lo, hi);
        setInput(DEFS[key].input, list);
      });
      if (typeof window.getData === 'function') {
        try { window.getData(); } catch(e){}
      }
    }, 250);
  }

  function wire() {
    KEYS.forEach(function(key){
      var col = document.querySelector('.sp-bn__col[data-key="'+key+'"]');
      if (!col || col.dataset.sp64 === '1') return;
      col.dataset.sp64 = '1';

      // 1. Watch the polish bar range inputs for ANY user change
      col.querySelectorAll('input[type="range"]').forEach(function(inp){
        inp.addEventListener('input', scheduleApply);
        inp.addEventListener('change', scheduleApply);
      });

      // 2. Click on tick labels → pin both handles + apply
      col.querySelectorAll('.sp-bn__tick').forEach(function(tick){
        tick.style.cursor = 'pointer';
        tick.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          var i = parseInt(tick.getAttribute('data-i'), 10);
          if (isNaN(i)) return;
          var minH = col.querySelector('.sp-rng__handle--min');
          var maxH = col.querySelector('.sp-rng__handle--max');
          if (!minH || !maxH) return;
          minH.value = i;
          maxH.value = i;
          minH.dispatchEvent(new Event('input', { bubbles: true }));
          maxH.dispatchEvent(new Event('input', { bubbles: true }));
          col.querySelectorAll('.sp-bn__tick.sp-pinned').forEach(function(t){ t.classList.remove('sp-pinned'); });
          tick.classList.add('sp-pinned');
          // Update polish-bar visuals
          var fill = col.querySelector('.sp-rng__fill');
          if (fill) {
            var pct = (i / (DEFS[key].values.length - 1)) * 100;
            fill.style.left = pct + '%';
            fill.style.right = (100 - pct) + '%';
          }
          var disp = col.querySelector('[data-value="'+key+'"]');
          if (disp) disp.textContent = DEFS[key].values[i];
          scheduleApply();
        }, true);
      });
    });
  }

  // Style ticks so they look clickable
  var style = document.createElement('style');
  style.textContent = [
    '.sp-bn__tick { cursor: pointer !important; padding: 4px 2px !important; border-radius: 4px !important; transition: background .12s ease; }',
    '.sp-bn__tick:hover { background: rgba(10, 29, 46, .08); }',
    '.sp-bn__tick.sp-pinned { background: #0A1D2E !important; color: #fff !important; font-weight: 700 !important; }'
  ].join('\n');
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
  setTimeout(wire, 700);
  setTimeout(wire, 2000);
  setInterval(wire, 1500);
})();

/* v65 (2026-04-21): FINAL FIX for single-value filter. v64's form writes got
   clobbered 250-300ms later by the polish bar's onChange handler and/or the
   native slider's 'update' event listeners. v65 bypasses those entirely —
   we override getData to always re-apply our filter values right before the
   actual API call, AND we write form values synchronously without firing
   input events. */
(function(){
  var DEFS = {
    cut:     { values: ['Good','Very Good','Excellent','Ideal'], input: 'diamondcut', allSuffix: ',8X' },
    color:   { values: ['K','J','I','H','G','F','E','D'], input: 'diamondcolor', allSuffix: '' },
    clarity: { values: ['SI2','SI1','VS2','VS1','VVS2','VVS1','IF','FL'], input: 'diamondclarity', allPrefix: 'I1,' }
  };

  // Our current single-value selection (null = all / not pinned)
  var pinned = { cut: null, color: null, clarity: null };

  function valueListForRange(key, lo, hi) {
    var d = DEFS[key];
    var full = d.values.length - 1;
    if (lo <= 0 && hi >= full) {
      if (key === 'color') return '';
      return (d.allPrefix||'') + d.values.join(',') + (d.allSuffix||'');
    }
    var slice = d.values.slice(Math.max(0, Math.round(lo)), Math.round(hi) + 1);
    return slice.join(',');
  }

  function writeFilterValues() {
    Object.keys(pinned).forEach(function(key){
      var inp = document.getElementById(DEFS[key].input);
      if (!inp) return;
      if (pinned[key] !== null) {
        // Single value pinned
        inp.value = DEFS[key].values[pinned[key]];
      }
      // If not pinned, leave whatever the polish bar / native slider set
    });
  }

  // Hook getData so our pinned values always win
  var origGetData = window.getData;
  if (typeof origGetData === 'function' && !origGetData.__v65wrapped) {
    window.getData = function() {
      writeFilterValues();
      return origGetData.apply(this, arguments);
    };
    window.getData.__v65wrapped = true;
  } else {
    // getData not defined yet — poll for it
    var gdInt = setInterval(function(){
      if (typeof window.getData === 'function' && !window.getData.__v65wrapped) {
        var o = window.getData;
        window.getData = function() {
          writeFilterValues();
          return o.apply(this, arguments);
        };
        window.getData.__v65wrapped = true;
        clearInterval(gdInt);
      }
    }, 300);
  }

  function pin(key, i) {
    pinned[key] = i;
    var col = document.querySelector('.sp-bn__col[data-key="'+key+'"]');
    if (col) {
      col.querySelectorAll('.sp-bn__tick.sp-pinned').forEach(function(t){ t.classList.remove('sp-pinned'); });
      col.querySelectorAll('.sp-bn__tick').forEach(function(t){
        if (parseInt(t.getAttribute('data-i'), 10) === i) t.classList.add('sp-pinned');
      });
      // Update fill bar + value display
      var fill = col.querySelector('.sp-rng__fill');
      if (fill) {
        var pct = (i / (DEFS[key].values.length - 1)) * 100;
        fill.style.left = pct + '%';
        fill.style.right = (100 - pct) + '%';
      }
      var disp = col.querySelector('[data-value="'+key+'"]');
      if (disp) disp.textContent = DEFS[key].values[i];
      // Also set handles visually for consistency (don't fire events)
      var minH = col.querySelector('.sp-rng__handle--min');
      var maxH = col.querySelector('.sp-rng__handle--max');
      if (minH) minH.value = i;
      if (maxH) maxH.value = i;
    }
    // Write to form input immediately (will be re-asserted via getData hook)
    var inp = document.getElementById(DEFS[key].input);
    if (inp) inp.value = DEFS[key].values[i];
    // For color specifically — also set .colorfilter pill state
    if (key === 'color') {
      document.querySelectorAll('.colorfilter').forEach(function(el){
        var v = (el.getAttribute('data-value') || '').trim().toUpperCase();
        el.classList.toggle('slide-active', v === DEFS[key].values[i].toUpperCase());
      });
    }
    if (typeof window.getData === 'function') { try { window.getData(); } catch(e){} }
  }

  function unpin(key) {
    pinned[key] = null;
    var col = document.querySelector('.sp-bn__col[data-key="'+key+'"]');
    if (col) {
      col.querySelectorAll('.sp-bn__tick.sp-pinned').forEach(function(t){ t.classList.remove('sp-pinned'); });
    }
  }

  function wire() {
    Object.keys(DEFS).forEach(function(key){
      var col = document.querySelector('.sp-bn__col[data-key="'+key+'"]');
      if (!col || col.dataset.sp65 === '1') return;
      col.dataset.sp65 = '1';
      col.querySelectorAll('.sp-bn__tick').forEach(function(tick){
        tick.style.cursor = 'pointer';
        tick.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          var i = parseInt(tick.getAttribute('data-i'), 10);
          if (isNaN(i)) return;
          if (tick.classList.contains('sp-pinned')) {
            unpin(key);
            if (typeof window.getData === 'function') try { window.getData(); } catch(e){}
          } else {
            pin(key, i);
          }
        }, true);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
  setTimeout(wire, 700);
  setTimeout(wire, 2000);
  setInterval(wire, 1500);
})();

/* v66 (2026-04-21): Network-layer interception. v65 lost the race because
   something later cleared diamondcolor before FormData was captured. v66
   intercepts XMLHttpRequest.send and axios/fetch to rewrite the outgoing
   form data with our pinned single values. Can't be clobbered. */
(function(){
  var DEFS = {
    cut:     { values: ['Good','Very Good','Excellent','Ideal'], input: 'diamondcut',    allSuffix: ',8X' },
    color:   { values: ['K','J','I','H','G','F','E','D'],        input: 'diamondcolor',  allSuffix: '' },
    clarity: { values: ['SI2','SI1','VS2','VS1','VVS2','VVS1','IF','FL'], input: 'diamondclarity', allPrefix: 'I1,' }
  };
  var pinned = { cut: null, color: null, clarity: null };

  function patchFormData(fd) {
    Object.keys(pinned).forEach(function(key){
      var p = pinned[key];
      if (p === null) return;
      var def = DEFS[key];
      var label;
      if (typeof p === 'number') {
        label = def.values[p];
      } else if (p && typeof p === 'object' && typeof p.lo === 'number' && typeof p.hi === 'number') {
        var lo = Math.max(0, Math.min(p.lo, def.values.length - 1));
        var hi = Math.max(0, Math.min(p.hi, def.values.length - 1));
        if (lo > hi) { var t = lo; lo = hi; hi = t; }
        label = def.values.slice(lo, hi + 1).join(',');
      } else {
        return;
      }
      if (def.allPrefix) label = def.allPrefix + label;
      if (def.allSuffix) label = label + def.allSuffix;
      try { fd.set(def.input, label); } catch(e){}
    });
    return fd;
  }

  // Intercept XMLHttpRequest.send (axios uses XHR by default)
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(body) {
    if (body instanceof FormData) {
      var hasFilter = false;
      try { for (var p of body.entries()) { if (/diamond|shape|carat|price/i.test(p[0])) { hasFilter = true; break; } } } catch(e){}
      if (hasFilter) patchFormData(body);
    }
    return origSend.apply(this, arguments);
  };

  // Also intercept fetch (if theme switches)
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function(input, init) {
      if (init && init.body instanceof FormData) {
        try {
          var hasFilter = false;
          for (var p of init.body.entries()) { if (/diamond|shape|carat|price/i.test(p[0])) { hasFilter = true; break; } }
          if (hasFilter) patchFormData(init.body);
        } catch(e){}
      }
      return origFetch.apply(this, arguments);
    };
  }

  function pin(key, i) {
    pinned[key] = i;
    var col = document.querySelector('.sp-bn__col[data-key="'+key+'"]');
    if (col) {
      col.querySelectorAll('.sp-bn__tick.sp-pinned').forEach(function(t){ t.classList.remove('sp-pinned'); });
      col.querySelectorAll('.sp-bn__tick').forEach(function(t){
        if (parseInt(t.getAttribute('data-i'), 10) === i) t.classList.add('sp-pinned');
      });
      var fill = col.querySelector('.sp-rng__fill');
      if (fill) {
        var pct = (i / (DEFS[key].values.length - 1)) * 100;
        fill.style.left = pct + '%';
        fill.style.right = (100 - pct) + '%';
      }
      var disp = col.querySelector('[data-value="'+key+'"]');
      if (disp) disp.textContent = DEFS[key].values[i];
      var minH = col.querySelector('.sp-rng__handle--min');
      var maxH = col.querySelector('.sp-rng__handle--max');
      if (minH) minH.value = i;
      if (maxH) maxH.value = i;
    }
    if (typeof window.getData === 'function') try { window.getData(); } catch(e){}
  }
  function unpin(key) {
    pinned[key] = null;
    var col = document.querySelector('.sp-bn__col[data-key="'+key+'"]');
    if (col) col.querySelectorAll('.sp-bn__tick.sp-pinned').forEach(function(t){ t.classList.remove('sp-pinned'); });
    if (typeof window.getData === 'function') try { window.getData(); } catch(e){}
  }

  /* v68 (2026-04-28): drag-driven pinning, no extra getData call.
     v67 fired getData() from inside the drag path AND the existing
     basic-panel chain (syncToNative @ 280ms -> noUiSlider -> adv-slider
     change -> getData) also fired one — two overlapping XHRs racing,
     and the slower stale response could overwrite the fresh one. v68
     just updates pinned and the hidden form input; the existing chain
     fires the single request, and the XHR/fetch interceptor patches
     the body using the up-to-date pinned at send time. Debounce
     shortened to 110ms so pinned is set well before the 280ms chain
     sends the request. */
  function pinRangeOrSingle(key, lo, hi) {
    var def = DEFS[key];
    var maxIdx = def.values.length - 1;
    var col = document.querySelector('.sp-bn__col[data-key="'+key+'"]');
    if (col) {
      col.querySelectorAll('.sp-bn__tick.sp-pinned').forEach(function(t){ t.classList.remove('sp-pinned'); });
    }
    if (lo === 0 && hi === maxIdx) {
      pinned[key] = null;
    } else if (lo === hi) {
      pinned[key] = lo;
      if (col) col.querySelectorAll('.sp-bn__tick').forEach(function(t){
        if (parseInt(t.getAttribute('data-i'), 10) === lo) t.classList.add('sp-pinned');
      });
    } else {
      pinned[key] = { lo: lo, hi: hi };
    }
    var inp = document.getElementById(def.input);
    if (inp) {
      var label = '';
      var p = pinned[key];
      if (p !== null) {
        if (typeof p === 'number') label = def.values[p];
        else label = def.values.slice(p.lo, p.hi + 1).join(',');
        if (label && def.allPrefix) label = def.allPrefix + label;
        if (label && def.allSuffix) label = label + def.allSuffix;
      }
      inp.value = label;
    }
  }

  function syncFromHandles(key) {
    var col = document.querySelector('.sp-bn__col[data-key="'+key+'"]');
    if (!col) return;
    var minH = col.querySelector('.sp-rng__handle--min');
    var maxH = col.querySelector('.sp-rng__handle--max');
    if (!minH || !maxH) return;
    var lo = parseInt(minH.value, 10);
    var hi = parseInt(maxH.value, 10);
    if (isNaN(lo) || isNaN(hi)) return;
    if (lo > hi) { var t = lo; lo = hi; hi = t; }
    pinRangeOrSingle(key, lo, hi);
  }

  var dragTimers = { cut: null, color: null, clarity: null };

  function wire() {
    Object.keys(DEFS).forEach(function(key){
      var col = document.querySelector('.sp-bn__col[data-key="'+key+'"]');
      if (!col || col.dataset.sp66 === '1') return;
      col.dataset.sp66 = '1';
      col.querySelectorAll('.sp-bn__tick').forEach(function(tick){
        tick.style.cursor = 'pointer';
        tick.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          var i = parseInt(tick.getAttribute('data-i'), 10);
          if (isNaN(i)) return;
          if (tick.classList.contains('sp-pinned')) unpin(key);
          else pin(key, i);
        }, true);
      });
      ['input','change'].forEach(function(evt){
        col.addEventListener(evt, function(e){
          var t = e.target;
          if (!t || !t.classList) return;
          if (!t.classList.contains('sp-rng__handle--min') && !t.classList.contains('sp-rng__handle--max')) return;
          clearTimeout(dragTimers[key]);
          dragTimers[key] = setTimeout(function(){ syncFromHandles(key); }, 110);
        }, true);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
  setTimeout(wire, 700);
  setTimeout(wire, 2000);
  setInterval(wire, 1500);
})();
